import { TableHeaderItem } from "@/views/components/YtoTable/TableHeaderItem";

// const defaultWidth = 300;

const tableHeader1: TableHeaderItem[] = [
  { prop: 'containerNo', label: '车签号', width: 130 ,fixed: "left"},
  { prop: 'ioStatus', label: '进出状态', width: 70 },
  { prop: 'roughWeight', label: '称入重KG', width: null },
  { prop: 'tareWeight', label: '车辆皮重KG', width: null },
  { prop: 'suttleWeight', label: '净重KG', width: null },
  { prop: 'loadingWeight', label: '装车重量KG', width: null },
  { prop: 'unloadingWeight', label: '卸车重量KG', width: null },
  { prop: 'weighingTimeStr', label: '称重时间', width: 130 },
  { prop: 'lineName', label: '线路名称', width: null },
  { prop: 'sourceOrgCodeName', label: '始发网点', width: 130 },
  { prop: 'carNumber', label: '车牌号码', width: null },
  { prop: 'carNumberExtend', label: '挂车车牌', width: null },
  { prop: 'serialNumber', label: '流水号', width: null },
  { prop: 'opOrgName', label: '操作中心名称', width: null },
  { prop: 'opUserName', label: '操作人', width: null },
  { prop: 'status', label: '状态', width: null ,fixed: "right" },
  { prop: 'memo', label: '提示/警告信息', width: null,fixed: "right" },
];
const tableHeader2: TableHeaderItem[] = [
  { prop: 'carNumber', label: '车牌号码', width: null },
  { prop: 'tareWeight', label: '称入皮重KG', width: null },
  { prop: 'weighDate', label: '称重时间', width: null },
  { prop: 'carSign', label: '车辆品牌', width: null },
  { prop: 'carType', label: '车辆类型', width: null },
  { prop: 'opOrgName', label: '操作中心名称', width: null },
  { prop: 'opUserName', label: '操作人', width: null },
  { prop: 'status', label: '状态', width: null },
  { prop: 'memo', label: '提示/警告信息', width: null},
];

const tableHeader3: TableHeaderItem[] = [
  { prop: 'containerNo', label: '车签号', width: 140 },
  { prop: 'ioStatusText', label: '进出状态', width: null, },
  { prop: 'roughWeight', label: '称入重KG', width: null },
  { prop: 'tareWeight', label: '车辆皮重', width: null },
  { prop: 'suttleWeight', label: '净重', width: null },
  { prop: 'loadingWeight', label: '装车重量', width: null },
  { prop: 'unloadingWeight', label: '卸车重量', width: null },
  { prop: 'weighingTimeStr', label: '称重时间', width: null },
  { prop: 'lineName', label: '线路名称', width: null },
  { prop: 'sourceOrgCodeName', label: '始发网点', width: null },
  { prop: 'carNumber', label: '车牌号', width: null },
  { prop: 'carNumberExtend', label: '挂车车牌', width: null },
  { prop: 'serialNumber', label: '流水号', width: null },
  { prop: 'opOrgName', label: '操作中心名称', width: null },
  { prop: 'opUserName', label: '操作人', width: 100 },
  { prop: 'statusText', label: '状态', width: null },
  { prop: 'memo', label: '提示/警告信息', width: null },
];
export default { tableHeader1, tableHeader2, tableHeader3 }
